import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {TranslateService} from 'ng2-translate';

import {
    Candidature,
    /*CandidatureFormation,*/
    CandidatureFormationOrder/*,
    CandidatureFormationService*/
} from '../candidature';
import {AlertService, JhiLanguageService} from 'ng-jhipster';
import {Response} from '@angular/http';
import {CONSTANTS} from '../../cadens.constants';
import {Parametrage, ParametrageService} from '../parametrage';
import {ExportService, Principal} from '../../shared';
import {ConfirmationService} from 'primeng/components/common/api';
import {NgbModal,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AideComponent} from '../../admin';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { CategorieFormationService, FormationService,Piece, PieceService } from '../formation';
import {PieceJointe, PieceJointeService} from '../piece-jointe';
import {CandidatureFormationService} from '../candidature/candidature-formation.service';
import {CandidatureFormation} from '../candidature/candidature-formation.model';

//import {FormationService, Piece, PieceService, QuestionService} from '../../formation';

@Component({
    selector: 'jhi-espace-candidat',
    templateUrl: 'espaceCandidat.component.html'
})
export class EspaceCandidatComponent implements OnInit,OnChanges {
    @Input() isSaving: Boolean;
    @Input() isEditable = true;
    @Input() isConfirmable = false;
    @Input() isClickable = false;
    @Input() isBO: number; // 0=candidat ; 1=BO lecture seule; 2=BO Modifiable
    @Input() candidatureFormationId: Number = null;
    @Input() candidatureFormation: CandidatureFormation = {};
    @Input() missingPieces: Boolean;
    @Output() missingPiecesChange: EventEmitter<Boolean> = new EventEmitter();
    piecesJointes: PieceJointe[] = [];
    maxSize = 2000000;
    pieces: Piece[] = [];
    otherUploadedFiles: any[] = [];
    attestationCandidat: Piece;
    lastIdx: number;
    alertId: number;
    choixConfirmation: number;
    private modalRef: NgbModalRef;
    private ngInitDone = false;
    private isReloading = false;
    candidatures: Candidature[];
    cfOrdreModifiable: CandidatureFormation[];
    cfOrdreNonModifiable: CandidatureFormation[];
    cfEnCoursOuSupprimmee: CandidatureFormation[];
    cfListeDesOrdres: CandidatureFormationOrder[];
    error: any;
    success: any;
    currentLang: string;
    parametrage: any;
    public constants = CONSTANTS;
    draggedCandidature: CandidatureFormation;
    formationsOpen = false;
    acceptLabel = 'delete';
    aide: Parametrage;
    reinscription = false;
    candidatureAutorisee = true;
    isLoading: boolean;
    nomFichierAide: string;

    // private reorder: any[] = [];

    private static sortByDateCreation(a: CandidatureFormation, b: CandidatureFormation): number {
        if (a.dateCreation > a.dateCreation) {
            return 1;
        } else {
            return -1;
        }
    }

    private static sortByOrder(a: CandidatureFormation, b: CandidatureFormation): number {
        if (a.ordre != null && b.ordre != null) {
            if (a.ordre != b.ordre) {
                if (a.ordre > b.ordre) {
                    return 1;
                } else {
                    return -1;
                }
            }
        } else {
            if (a.ordre != null) {
                return 1;
            }
            if (b.ordre != null) {
                return -1;
            }
        }
        if (a.dateCreation != null && b.dateCreation != null) {
            if (a.dateCreation < b.dateCreation) {
                return 1;
            } else {
                return -1;
            }
        }
        return 0;
    }

    private static isbefore(a, b) {
        if (a.parentNode === b.parentNode) {
            for (let cur = a; cur; cur = cur.previousSibling) {
                if (cur === b) {
                    return true;
                }
            }
        }
        return false;
    }
    private static getCookie(name) {
        let value = '; ' + document.cookie;
        let parts = value.split('; ' + name + '=');
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
    }
    constructor(private candidatureFormationService: CandidatureFormationService,
                private principal: Principal,
                private jhiLanguageService: JhiLanguageService,
                private parametrageService: ParametrageService,
                private categorieFormationService: CategorieFormationService,
                private alertService: AlertService,
                private router: Router,
                private confirmationService: ConfirmationService,
                private translateService: TranslateService,
                private modalService: NgbModal,
                private exportService: ExportService,
                private translate: TranslateService,
                private formationService: FormationService,
                private pieceJointeService: PieceJointeService,
                private pieceService: PieceService
    ) {
        this.jhiLanguageService.setLocations(['candidature', 'global']);
        this.currentLang = '' + this.jhiLanguageService.currentLang;
    }

    /**
     * ngOnInit is called when the page is loaded
     * Load the candidatures and the parametrage for the page (contains some libelles)
     */
    ngOnInit() {
        this.loadAll();
        this.parametrageService.query({page: CONSTANTS.ESPACECANDIDAT}).subscribe(
            (res: Response) => {
                this.parametrage = this.parametrageService.parametresArrayToObject(res.json());
            });
        this.translate.onLangChange.subscribe(lang => this.currentLang = lang.lang);
        this.rechercheNomFichierAide();

        this.ngInitDone = true;
        //DEBUT
        this.otherUploadedFiles = [];

        this.ngInitDone = true;
        //FIN

    }
    /**
     * Check if one of the PJ is mandatory and missing
     */
    private isMissingPJ() {
        if (this.pieces != null && this.pieces.length > 0) {
            if (this.piecesJointes == null || this.piecesJointes.length === 0) {
                this.missingPieces = true;
            } else {
                let piecesMandat = this.pieces.filter(p => p.obligatoire === true);
                let pjMandat = this.piecesJointes.filter(pj => piecesMandat.findIndex(p => p.id === pj.pieceId) > -1);
                this.missingPieces = piecesMandat.length > pjMandat.length;
            }
        } else {
            this.missingPieces = false;
        }
        this.missingPiecesChange.emit(this.missingPieces);
    }
    /****
     * ngOnChanges is called where change on page
     * ****/
    ngOnChanges(changes: any) {
        if (((changes['candidatureFormation'] != null
                && changes['candidatureFormation'].previousValue.id != null
                && changes['candidatureFormation'].previousValue.id !== changes['candidatureFormation'].currentValue.id) ||
                (changes['candidatureFormationId'] != null
                    && changes['candidatureFormationId'].previousValue != null
                    && changes['candidatureFormationId'].previousValue !== changes['candidatureFormationId'].currentValue) ||
                (changes['candidatureFormationFc'] != null
                    && changes['candidatureFormationFc'].previousValue != null
                    && changes['candidatureFormationFc'].previousValue !== changes['candidatureFormationFc'].currentValue)
            )
            && !this.isReloading
            && this.ngInitDone) {
            this.isReloading = true;
            //this.pieces = [];
            this.otherUploadedFiles = [];
           // this.uploadedFiles = new KeyedCollection<any>();
            //this.referents = [];
           // this.piecesJointes = [];
           // this.ngOnInit();
        }
    }
    /**
     * Load all the candidatures from candidatureFormation for the connected user
     */
    loadAll() {
        this.principal.identity().then((account) => {
            if (account.etudiant != null && account.etudiant.numeroEtudiant != null) {
                this.reinscription = true;
            } else {
                if (account.email.endsWith('@ens-lyon.fr')) {
                    this.candidatureAutorisee = false;
                }
            }
            this.isLoading = true;

            //this.isBo=0;//candidat
            this.candidatureFormationService.query({userId: account.id}).subscribe(
                (resCandidature: Response) => {
                    this.candidatureFormationService.findCandidatureOrdre({userId: account.id}).subscribe(
                        (resOrdre: Response) => {
                            const candidatureJson: CandidatureFormation[] = resCandidature.json();
                            const candidaturesAvecFormation = candidatureJson.filter(cf => cf.formationId != null);
                            // Initialisation de la formation de chacune des candidatures
                            if(candidaturesAvecFormation.length === 0) {
                                this.onSuccess(candidatureJson, resOrdre.json());
                                this.isLoading = false;
                            } else {
                                forkJoin(candidaturesAvecFormation.map(candidatureFormation => this.formationService.find(candidatureFormation.formationId))).subscribe(
                                    (res) => {
                                        candidaturesAvecFormation.forEach((cf, i) => candidaturesAvecFormation[i].formation = res[i]);
                                        this.onSuccess(candidatureJson, resOrdre.json());
                                        this.isLoading = false;
                                    },
                                    (err) => {
                                        this.isLoading = false;
                                        this.onError(err);
                                    }
                                );
                            }
                        },

                        (resOrdre: Response) => {
                            this.isLoading = false;
                            this.onError(resOrdre);
                        }
                    );
                },
                (resCandidature: Response) => {
                    this.isLoading = false;
                    this.onError(resCandidature);
                }
            );
            this.categorieFormationService.queryDisponibles({
                etudiantId: account.id,
                reinscription: this.reinscription,
                lecture: false
            }).subscribe(
                (res: Response) => {
                    let cats = res.json();
                    if (cats && cats.length > 0) {
                        if (cats.find(cat => !cat.disabled)) {
                            this.formationsOpen = true;
                        }
                    }
                });
        });
    }

    /**
     * Redirect to the candidature on button click
     * @param id
     */
    open(id) {
        this.router.navigate(['/candidature/' + id]);
    }

    delete(id) {
        this.confirmationService.confirm({
            message: this.translateService.instant('cadensApp.espaceCandidat.delete.question'),
            header: this.translateService.instant('cadensApp.espaceCandidat.delete.title'),
            icon: 'fa fa-trash',
            key: 'confirmDelete',
            accept: () => {
                this.isLoading = true;
                this.candidatureFormationService.delete(id).subscribe(res => {
                        this.loadAll();
                    },
                    (res) => {
                        this.isLoading = false;
                        this.onError(res);
                    });
            }
        });
    }

    /**
     * Le candidat se désiste pour une candidature
     * @param candidatureFormation
     */
    desistResponse(candidatureFormation: CandidatureFormation) {
        this.acceptLabel = 'desist';
        const messageValue = candidatureFormation.response === CONSTANTS.AWAITING ?
            'cadensApp.espaceCandidat.desist.questionLC' : 'cadensApp.espaceCandidat.desist.question';
        this.confirmationService.confirm({
            message: this.translateService.instant(messageValue),
            header: this.translateService.instant('cadensApp.espaceCandidat.desist.title'),
            icon: 'fa fa-ban',
            accept: () => {
                this.candidatureFormationService.updateCandidaturesStatus([candidatureFormation],
                    {statut: CONSTANTS.DESISTED}).subscribe(res => {
                    this.loadAll();
                });
            }
        });
    }
    onChangeChoix(newChoix) {
        this.isClickable=true;
        this.otherUploadedFiles = [];

       // ngOnInitPj(candidatureFormation: CandidatureFormation);
        //this.annee = null;
       // this.cleanInfos();
    }
    /**
     * Le candidat confirme sa venue pour une candidature
     * @param candidatureFormation
     */
    confirmResponse(candidatureFormation: CandidatureFormation) {
        this.acceptLabel = 'confirm';
        this.confirmationService.confirm({
            message: this.translateService.instant('cadensApp.espaceCandidat.confirm.question'),
            header: this.translateService.instant('cadensApp.espaceCandidat.confirm.title'),
            icon: 'fa fa-handshake-o',
            accept: () => {
                this.candidatureFormationService.updateCandidaturesStatus([candidatureFormation],
                    {statut: CONSTANTS.CONFIRMED}).subscribe(res => {
                    this.loadAll();
                });
            }
        });
    }
    confirmResponseAvecChoix(candidatureFormation: CandidatureFormation,choix?: number) {
        this.acceptLabel = 'confirm';
        this.choixConfirmation=choix;
        this.confirmationService.confirm({
            message: this.translateService.instant('cadensApp.espaceCandidat.confirm.question'),
            header: this.translateService.instant('cadensApp.espaceCandidat.confirm.title'),
            icon: 'fa fa-handshake-o',
            accept: () => {
                this.candidatureFormationService.updateCandidaturesStatus([candidatureFormation],
                    {statut: CONSTANTS.CONFIRMED,choixConfirmation: this.choixConfirmation}).subscribe(res => {
                    this.loadAll();
                });
            }
        });
    }

    /** MANAGE Ordre des candidature par DragNDrop (https://www.primefaces.org/primeng/#/dragdrop) **/
    dragStart(event, candidatureF: CandidatureFormation) {
        if (event.target.nodeName === 'LI' && candidatureF.dateSuppression == null && candidatureF.dateValidation != null) {
            // Quand le user pick une candidature, l'enregistrer
            this.draggedCandidature = event.target;
            event.dataTransfer.effectAllowed = 'move';
        }
    }

    dragEnd(event) {
        // A la fin du drag&drop, enregistrer le nouvel ordre!
        let updates = [];
        this.cfOrdreModifiable.forEach(candidatureFormation => {
            updates.push(candidatureFormation);
        });
        // this.reorder.forEach((candi, index) => {
        //     let candidatureFormation = this.cfOrdreModifiable.find(cf => cf.id === Number(candi));
        //     candidatureFormation.ordre = index + 1;
        //     updates.push(candidatureFormation);
        // });
        if (updates.length > 0) {
            this.isLoading = true;
            this.candidatureFormationService.updateCandidaturesOrder(updates).subscribe(
                res => {
                    this.loadAll();
                },
                error => {
                    this.isLoading = false;
                    this.onError({message: 'cadensApp.candidature.messages.error.modificationOrdre'});
                }
            );
        }
        this.draggedCandidature = null;
    }

    dragEnter(event) {
        let target = event.target;
        if (target.nodeName === 'LI' && this.draggedCandidature) {
            if (target.attributes.getNamedItem('draggable') != null) {
                // Appelé pendant le drag&drop process, permet d'insérer un LI avant/après un autre
                if (EspaceCandidatComponent.isbefore(this.draggedCandidature, target)) {
                    target.parentNode.insertBefore(this.draggedCandidature, target);
                } else {
                    target.parentNode.insertBefore(this.draggedCandidature, target.nextSibling);
                }
                if (target.parentNode.id === 'parentUL') {
                    // Récupérer l'ordre des 'LI' à chaque fois que ça change
                    // this.reorder = [];
                    // L'id des candidature est l'ID du 'LI'
                    let minOrdre: number = Math.min(...this.cfOrdreModifiable.map(function (o) {
                        return o.ordre;
                    }));
                    for (let i in target.parentNode.children) {
                        // this.reorder.push(target.parentNode.children[i].id) ;
                        this.cfOrdreModifiable.filter(candidature => {
                            // noinspection JSUnfilteredForInLoop
                            return candidature.id.toString() === target.parentNode.children[i].id;
                        }).forEach(candidatureTrouvee => {
                            // noinspection JSUnfilteredForInLoop
                            candidatureTrouvee.ordre = minOrdre;
                        });
                        minOrdre++;
                    }
                }
            }
        }
    }

    drop(event) {
        this.draggedCandidature = null;
    }

    // Open la popup d'aide
    openAide(aideModal) {
        this.modalService.open(aideModal);
    }


    // Generation du document suivants status acceptation, refus, attente
    genererLettreAdmission(candiId: number, pourReponseCode: string, sortieListeComplementaire: Boolean) {
        let lc: String = '_';
        if (sortieListeComplementaire == true) {
            lc = 'lc';
        }
        let fileName: String = 'reponseENS' + lc + candiId + '.pdf';
        this.candidatureFormationService.genererLettreAdmission(candiId, pourReponseCode, sortieListeComplementaire).subscribe((res) => {
                ExportService.download(res, fileName);
            },
            (error => {
                this.onError({message: 'cadensApp.candidature.messages.error.genererLettreAdmission'});
            }));
    }

    private onSuccess(candidatureJson, ordreJson) {
        this.cfListeDesOrdres = ordreJson;
        let cfAll: CandidatureFormation[];
        cfAll = candidatureJson;

        cfAll.forEach(candidature => {
            candidature.ordreModifiable = false;
            if (this.cfListeDesOrdres != null) {
                this.cfListeDesOrdres.forEach(ordre => {
                    if (ordre.id == candidature.id) {
                        candidature.ordre = ordre.ordre;
                        if (ordre.ordreModifiable != null) {
                            candidature.ordreModifiable = ordre.ordreModifiable;
                        }
                    }
                });
            }
        });

        this.cfEnCoursOuSupprimmee = cfAll
            .filter(candi => candi.dateSuppression != null || candi.dateValidation == null)
            .sort(EspaceCandidatComponent.sortByDateCreation);
        this.cfOrdreModifiable = cfAll
            .filter(candi => !(candi.dateSuppression != null || candi.dateValidation == null) && candi.ordreModifiable == true)
            .sort(EspaceCandidatComponent.sortByOrder);
        this.cfOrdreNonModifiable = cfAll
            .filter(candi => !(candi.dateSuppression != null || candi.dateValidation == null) && candi.ordreModifiable == false)
            .sort(EspaceCandidatComponent.sortByOrder);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    private rechercheNomFichierAide() {
        this.parametrageService.getFileName(AideComponent.categorieAide, 'ROLE_USER').subscribe(
            (res: Response) => {
                if (res != null && res.text() != null && res.text().length > 0) {
                    this.nomFichierAide = res.text();
                }
            }
            ,
            (res: Response) => this.onError(res)
        );
    }

    private openFichierAide() {
        this.parametrageService.getFile(AideComponent.categorieAide, 'ROLE_USER').subscribe(
            (file: Blob) => {
                ExportService.download(file, 'ROLE_USER');
            },
            (response) => {
                this.onError(response);
            });
    }

    /******
     *
     * Televerser attestation
     *
     */

    // Open la popup d'aide
    openModalConfirmationEcts180(otherPieceModalAttestation) {
        this.modalService.open(otherPieceModalAttestation);
    }
    // Open a file in a new tab when click on it
    openFile(name: string) {
        // Get la liste des pièces jointes déjà uploadées
        this.pieceJointeService.openFile(name).subscribe((res) => {
                let fileUrl = URL.createObjectURL(res);
                window.open(fileUrl);
            },
            error => {
                this.isSaving = false;
                this.onError(error);
            });
    }
    // Autres pièces justificatives
    addOtherPJ(modal, idx?: number,choix?: number, candidatureFormation?: CandidatureFormation) {
        this.modalRef = this.modalService.open(modal);
        this.choixConfirmation=choix;
        this.candidatureFormation=candidatureFormation;
        if (!this.otherUploadedFiles) {
            this.otherUploadedFiles = [];
        }
        if (idx != null) {
            this.lastIdx = idx;
        } else {
            this.otherUploadedFiles.push({pieceId: 1});
            if(choix==1){
                this.otherUploadedFiles.push({notes: "Attestation sur l'honneur"})
            }else{
                this.otherUploadedFiles.push({notes: 'Attestation de démission'})}
            this.lastIdx = this.otherUploadedFiles.length - 1;

        }
    }

    closeOtherPJ() {
        if (this.otherUploadedFiles[this.lastIdx].id == null) {
            this.otherUploadedFiles.pop();
        }
        this.modalRef.close();
    }
    // Before the file is sent to the server for upload
    // noinspection JSMethodCanBeStatic
    onBeforeSend(event) {
        event.xhr.setRequestHeader('X-XSRF-TOKEN', EspaceCandidatComponent.getCookie('XSRF-TOKEN'));
    }
    // Before the file is sent to the server for upload
    onBeforeUpload(event, id) {
        this.onBeforeUploadAttestation(event, id);
    }
// Before the file is sent to the server for upload
    onBeforeUploadAttestation(event, id) {
        event.formData.append('pieceId', id);
        if (this.otherUploadedFiles != null && id === 1 && this.lastIdx != null
            && this.otherUploadedFiles[this.lastIdx] != null) {
            event.formData.append('pieceJointeId',
                this.otherUploadedFiles[this.lastIdx].id == null ? -1 : this.otherUploadedFiles[this.lastIdx].id);
        }
        this.alertId = id;
        event.formData.append('candidatureFormationId', this.candidatureFormation.id);
       /* if (referentId != null) {
            event.formData.append('referentId', referentId);
        }*/
    }
    onOtherFileUploaded(event) {
        let pj: PieceJointe = JSON.parse(event.xhr.response);
        let notes = this.otherUploadedFiles[this.lastIdx].notes;
        this.otherUploadedFiles[this.lastIdx] = pj;
        this.otherUploadedFiles[this.lastIdx].notes = notes;
    }

    saveOtherPJ(modal,choix?: number) {

        if (this.otherUploadedFiles[this.lastIdx].nom != null) {

            this.pieceJointeService.update(this.otherUploadedFiles[this.lastIdx]).subscribe((res) => {

                    this.otherUploadedFiles[this.lastIdx] = res;
                    this.modalRef.close();
                },
                error => {
                    this.isSaving = false;
                    this.onError(error);
                });

            //confirmation de la venue
            this.choixConfirmation=choix;
            this.confirmResponseAvecChoix(this.candidatureFormation,this.choixConfirmation);
        }

    }
    deleteOtherPJ() {
        this.pieceJointeService.delete(this.otherUploadedFiles[this.lastIdx].id).subscribe((res) => {
                this.otherUploadedFiles.splice(this.lastIdx, 1);
                this.modalRef.close();
            },
            error => {
                this.isSaving = false;
                this.onError(error);
            });
    }
    ngOnInitPj() {
        this.translate.onLangChange.subscribe(lang => this.currentLang = lang.lang);
        this.isSaving = true;
        if (this.candidatureFormation != null && this.candidatureFormation.id != null && this.candidatureFormation.formationId != null) {

        }
    }
    /*ngOnInitPj() {
        if (this.loadReferentEvents != null) {
            this.loadReferentSubscription = this.loadReferentEvents.subscribe(() => {
                this.loadReferents();
            });
        }
        this.translate.onLangChange.subscribe(lang => this.currentLang = lang.lang);
        this.isSaving = true;
        // Get les paramétrages des pièces jointes
        this.parametrageService.query({page: CONSTANTS.PIECES}).subscribe(
            (res: Response) => {
                this.parametrage = this.parametrageService.parametresArrayToObject(res.json());
                this.maxSize = this.parametrage.MAX_SIZE.libelle;
            });
        if (this.candidatureFormation != null && this.candidatureFormation.id != null && this.candidatureFormation.formationId != null) {
            // get de la pièce recommandation
            let getPiece = this.pieceService.findByCode('LETTRE_RECOMMANDATION').subscribe((res: Response) => {
                this.lettreRecommandation = res;
            });

            // Get la liste des pièces jointes déjà uploadées
            this.pieceJointeService.query({candidatureFormationId: this.candidatureFormation.id}).subscribe((res: Response) => {
                this.piecesJointes = res.json();
                this.piecesJointes.forEach(pj => {
                    if (pj.pieceId === 1) {
                        this.otherUploadedFiles.push(pj);
                    } else {
                        this.uploadedFiles.Add(this.getPieceIndex(pj.pieceId, pj.referentId), pj);
                    }
                });

                // Get la liste des pièces pour la formation choisie
                let categorieFormationIdList: Number[] = [];
                categorieFormationIdList.push(this.candidatureFormation.categorieFormationId);
                this.pieceService.query({
                    categorieFormationIdList: categorieFormationIdList,
                    formationId: this.candidatureFormation.formationId,
                    isFormationContinue: this.candidatureFormation.fc,
                    etudiantId: this.candidatureFormation.userId
                }).subscribe((piecesResp: Response) => {
                    this.pieces = piecesResp.json();
                    this.isMissingPJ();
                    this.isSaving = false;
                    this.isReloading = false;
                });
                this.loadPJContent(); // Chargement de la visu des pj dans le BO
            });
            this.loadReferents();
        } else {
            this.isSaving = false;
            this.isReloading = false;
        }
        this.ngInitDone = true;
    }*/

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/espaceCandidat/espaceCandidat.component.ts